import { defineMessages } from 'react-intl';

export const sagaMessages = defineMessages({
  duplicateSchedulesDetected: {
    id: 'schedules.classtivity-scheduler.saga.duplicate-schedules-detected',
    defaultMessage: 'Adding new schedules will result in duplicates. Those are marked with red color.',
  },
  createClassSuccess: {
    id: 'schedules.classtivity-scheduler.saga.create-class-success',
    defaultMessage: 'Class has been successfully created',
  },
  createClassError: {
    id: 'schedules.classtivity-scheduler.saga.create-class-error',
    defaultMessage: 'There was a problem creating a new class',
  },
});
